import { isString } from "./type_guards";
import { validateNonEmptyString } from "./validators";

export type UserType = 'USER' | 'AGENT' | 'COMPANY' | 'COMMONSKU';

export const isUserType = (value: unknown): value is UserType =>
    value === 'USER' ||
    value === 'AGENT' ||
    value === 'COMPANY' ||
    value === 'COMMONSKU';

export interface DisplayUser {
    id: string
    firstName?: string
    lastName?: string
    avatarImagePath?: string
    mask?: string
    userType?: UserType
}

// Type guards
export const isDisplayUser = (user: unknown): user is DisplayUser => {
    if (
        typeof user !== 'object' ||
        !('id' in user)
    ) {
        return false;
    }

    return (
        isString(user.id) &&
        (!('firstName' in user) || user.firstName === undefined || isString(user.firstName)) &&
        (!('lastName' in user) || user.lastName === undefined || isString(user.lastName)) &&
        (!('avatarImagePath' in user) || user.avatarImagePath === undefined || isString(user.avatarImagePath)) &&
        (!('mask' in user) || user.mask === undefined || isString(user.mask)) &&
        (!('userType' in user) || user.userType === undefined || isUserType(user.userType))
    );
};

// Validators
export const validateDisplayUser = (user: DisplayUser) => {
    validateNonEmptyString(user.id);
};
